import type { ReactFlowInstance } from 'reactflow';
import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';
import {
  getNearestNodeByType,
  getNodesBetween,
  recalculateHandlePositions,
  createDirectedEdge
} from '@src/scenario-editor/render-utils';
import { recalculateNodesYPosForNodes, recalculateNodesXPos } from '@src/scenario-editor/utils';

export const deleteStatementBranch = (instance: ReactFlowInstance, node: CustomNode, branchIndex: number) => {
  const nodes = instance.getNodes() as CustomNode[];
  const edges = instance.getEdges() as CustomEdge[];
  const branchNumber = branchIndex + 1;
  const nodeBranchIndexPosition = node.branchId.split('-').length;

  const startNode = node;
  const endNode = getNearestNodeByType(nodes, edges, node, 'IfCloseNode');

  if (!endNode) {
    return;
  }

  const nodesBetween = getNodesBetween(nodes, edges, startNode, endNode);
  const nodesGroupedByBranch= nodesBetween.reduce((acc: Record<string, CustomNode[]>, node) => {
    const branchIndex = node.branchId.split('-')[nodeBranchIndexPosition];
    acc[branchIndex] = acc[branchIndex] ?? [];
    acc[branchIndex].push(node);
    return acc;
  }, {});

  let updatedNodes = nodes.filter((node) => !nodesGroupedByBranch[branchNumber].map((n) => n.id).includes(node.id));

  const branchesAfterDeletedBranch = Object.keys(nodesGroupedByBranch).filter((branch) => Number(branch) > branchNumber);
  const indexPlaceToUpdate = node.branchId.split('-').length;

  if (branchesAfterDeletedBranch.length) {
    branchesAfterDeletedBranch.forEach((branchChunk) => {
      const idsOfNodesBetween = nodesBetween.map((n) => n.id);
      updatedNodes = updatedNodes.map((node => {
        if (node.branchId.split('-')[indexPlaceToUpdate] === branchChunk && idsOfNodesBetween.includes(node.id)) {
          const splittedBranchId = node.branchId.split('-');
          const branchId =
            `${splittedBranchId.slice(0, indexPlaceToUpdate).join('-')}-`
              + (Number(branchChunk) - 1)
              + (splittedBranchId.slice(indexPlaceToUpdate + 1).length
                ? `-${splittedBranchId.slice(indexPlaceToUpdate + 1).join('-')}`
                : '');
          const parentBranchId = branchId.split('-').slice(0, -1).join('-');
          const nodeWithUpdatedBranchId = {
            ...node,
            branchId,
            parentBranchId
          }
          return nodeWithUpdatedBranchId;
        }

        return node;
      }))
    });
  }

  recalculateNodesYPosForNodes(updatedNodes, edges);
  recalculateNodesXPos(updatedNodes, undefined, { instance });
  recalculateHandlePositions(updatedNodes, edges);

  const updatedEdges = edges.filter((edge) => {
    return !nodesGroupedByBranch[branchNumber].map((n) => n.id).includes(edge.source)
      && !nodesGroupedByBranch[branchNumber].map((n) => n.id).includes(edge.target);
  })

  if (Object.keys(nodesGroupedByBranch).length === 1) {
    updatedEdges.push(createDirectedEdge(startNode.id, endNode.id, { targetHandle: 'top' }));
  }

  return {
    updatedNodes,
    updatedEdges,
  }
}
